// extracted by mini-css-extract-plugin
module.exports = {"select":"AddTeamModal_select__31Snc"};